export const DANISH = 'da'
export const DUTCH = 'nl'
export const ENGLISH = 'en'
export const ENGLISH_GB = 'en-gb'
export const FINNISH = 'fi'
export const FRENCH = 'fr'
export const GERMAN = 'de'
export const GREEK = 'el'
export const HUNGARIAN = 'hu'
export const ICELANDIC = 'is'
export const ITALIAN = 'it'
export const NORWEGIAN = 'no'
export const POLISH = 'pl'
export const PORTUGUESE = 'pt'
export const SPANISH = 'es'
export const SWEDISH = 'sv'
